
let CONFIG = {
    //开发环境配置
    development: {
        // baseUrl:"http://admin.zr-net.com/prod-api",
        // baseUrl:"http://5km5bs.natappfree.cc", 
		 // baseUrl:"http://j2t45h.natappfree.cc", 
		 
		 baseUrl:"https://test.jianyidu.com/prod-api", 
		// baseUrl:"http://3ddpz5.natappfree.cc",
        ossUrl: "https://language-training.oss-cn-hangzhou.aliyuncs.com"
    },
    //开发环境 打包后配置
    production: {
         baseUrl:"https://jianyidu.com/prod-api",
		 // baseUrl:"https://test.jianyidu.com/prod-api", 
         ossUrl: "https://language-training.oss-cn-hangzhou.aliyuncs.com"
    }
};
// 生产： jianyidu.com  admin.jianyidu.com

// 测试：test.jianyidu.com  test-admin.jianyidu.com

export default CONFIG[process.env.NODE_ENV];